export class Resolution {
  constructor(
    public width: number,
    public height: number,
  ) {}

  public duplicate() {
    return new Resolution(this.width, this.height);
  }
}

export class ResolutionPreset extends Resolution {
  constructor(
    public presetName: string,
    public width: number,
    public height: number,
  ) {
    super(width, height);
  }
  public duplicate() {
    return new ResolutionPreset(this.presetName, this.width, this.height);
  }
}

export class ChannelCodec {
  constructor(
    public id: number,
    public name: string,
    public isDefault: boolean,
    public video: VideoCodecSettings,
    public audio: AudioCodecSettings,
  ) {}
}

export class VideoCodecSettings {
  constructor(
    public codecType: number,
    public resolution: Resolution,
    public fps: number,
    public profile: number,
    public bitrate: number,
    public gopSize: number,
    public interlaceType: number,
    public muxOverhead: number,
    public specialOptions: string,
    public colourSpace: number,
    public mpegColourRange: boolean,
  ) {}
}

export class AudioCodecSettings {
  constructor(
    public codecType: number,
    public channels: number,
    public samplerate: number,
    public bitrate: number,
    public specialOptions: string,
  ) {}
}
